import { GoldButton } from "@/components/primitives";
import { Reveal } from "@/components/Reveal";
import { site } from "@/config/site";

// Full-width premium CTA panel with a restrained radial gold illumination.
export default function CTABlock() {
  return (
    <section className="relative overflow-hidden border-t border-fs-border bg-fs-bg py-24 lg:py-32">
      {/* radial gold glow */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-70"
        style={{
          background:
            "radial-gradient(circle, rgba(197,162,74,0.16) 0%, rgba(197,162,74,0.05) 35%, transparent 70%)",
        }}
      />
      <div className="fs-shell relative text-center">
        <Reveal>
          <h2 className="mx-auto max-w-3xl fs-h2">
            Ready to build a business that runs better
            <span className="fs-italic-gold"> —and grows faster?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-6 max-w-xl fs-body">
            Let's identify the gaps, priorities, and systems your business needs next.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <GoldButton href={site.bookingUrl} target="_blank" rel="noopener noreferrer" variant="solid" testId="cta-book-call">
              Book a Strategy Call
            </GoldButton>
            <GoldButton to="/services" variant="ghost" testId="cta-view-services">
              View Our Services
            </GoldButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
